
import { useNavigate, useLocation } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const navigateToHomeSection = (sectionId: string) => {
    if (isHomePage) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  const goToHome = () => {
    if (isHomePage) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const goToPage = (path: string) => {
    navigate(path);
  };

  return (
    <footer className="bg-[#0A1628] relative overflow-hidden">
      {/* Hospital Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(#6D28D9 1px, transparent 1px), linear-gradient(90deg, #6D28D9 1px, transparent 1px)`,
          backgroundSize: '100px 100px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-6 sm:pt-10 pb-3 sm:pb-5">
        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-12 mb-4 sm:mb-6">
          {/* Brand Section - Left */}
          <div className="lg:col-span-4">
            <img 
              src="/images/logo-prebed.png" 
              alt="PreBedAI Logo" 
              className="h-[42px] sm:h-[78px] w-auto mb-2 sm:mb-4"
            />
            <p className="text-xs sm:text-base text-white/80 leading-relaxed max-w-sm">
              Gestión Inteligente de Camas y Altas Hospitalarias
            </p>
          </div>

          {/* Navigation Section - Center/Right */}
          <div className="lg:col-span-8">
            <div className="grid grid-cols-3 sm:grid-cols-5 gap-4 sm:gap-8">
              {/* Column 1 - Inicio */}
              <div>
                <h4 className="text-white font-semibold text-[11px] sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">Inicio</h4>
                <ul className="space-y-1.5 sm:space-y-3">
                  <li>
                    <button 
                      onClick={goToHome}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Inicio
                    </button>
                  </li>
                </ul>
              </div>

              {/* Column 2 - Producto */}
              <div>
                <h4 className="text-white font-semibold text-[11px] sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">Producto</h4>
                <ul className="space-y-1.5 sm:space-y-3">
                  <li>
                    <button 
                      onClick={() => navigateToHomeSection('problem-section')}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Problema
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => navigateToHomeSection('solution-section')}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Solución
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => goToPage('/modulos')}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Módulos
                    </button>
                  </li>
                </ul>
              </div>

              {/* Column 3 - Recursos */}
              <div>
                <h4 className="text-white font-semibold text-[11px] sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">Recursos</h4>
                <ul className="space-y-1.5 sm:space-y-3">
                  <li>
                    <button 
                      onClick={() => goToPage('/integraciones')}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Integración
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => goToPage('/faq')}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      FAQ
                    </button>
                  </li>
                </ul>
              </div>

              {/* Column 4 - Empresa */}
              <div>
                <h4 className="text-white font-semibold text-[11px] sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">Empresa</h4>
                <ul className="space-y-1.5 sm:space-y-3">
                  <li>
                    <button 
                      onClick={() => goToPage('/nosotros')}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Nosotros
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => navigateToHomeSection('final-cta')}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Contacto
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => navigateToHomeSection('final-cta')}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Solicitar piloto
                    </button>
                  </li>
                </ul>
              </div>

              {/* Column 5 - Acceso */}
              <div>
                <h4 className="text-white font-semibold text-[11px] sm:text-sm uppercase tracking-wider mb-2 sm:mb-4">Acceso</h4>
                <ul className="space-y-1.5 sm:space-y-3">
                  <li>
                    <button 
                      onClick={() => window.location.href = 'https://prebedai.mct-origin.es'}
                      className="text-white/70 hover:text-[#06B6D4] transition-colors text-[11px] sm:text-sm"
                    >
                      Iniciar sesión
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-3 sm:pt-4 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
            {/* Copyright */}
            <p className="text-white/60 text-[10px] sm:text-sm order-2 sm:order-1">
              © 2026 PreBedAI. Todos los derechos reservados.
            </p>

            {/* Legal Links */}
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-4 text-white/60 text-[10px] sm:text-sm order-1 sm:order-2">
              <button onClick={() => goToPage('/politica-privacidad')} className="hover:text-[#06B6D4] transition-colors">Privacidad</button>
              <button onClick={() => goToPage('/terminos-condiciones')} className="hover:text-[#06B6D4] transition-colors">Términos</button>
              <button onClick={() => goToPage('/politica-cookies')} className="hover:text-[#06B6D4] transition-colors">Cookies</button>
              <button onClick={() => goToPage('/aviso-legal')} className="hover:text-[#06B6D4] transition-colors">Aviso Legal</button>
            </div>

            {/* Social */}
            <div className="order-3">
              <a 
                href="https://www.linkedin.com/company/prebedai/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-8 h-8 sm:w-10 sm:h-10 border-2 border-white/20 rounded-lg flex items-center justify-center text-white/70 hover:text-white hover:bg-[#06B6D4] hover:border-[#06B6D4] transition-all"
              >
                <i className="ri-linkedin-fill text-base sm:text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
